import { LoginDto } from "../../types/auth";

export const demoLoginDto: LoginDto = {
  apiToken: "demo-api-token-wrapsody-eco",
  userInfo: {
    userId: "demo.user",
    userName: "Demo User",
    userEmail: "demo.user@wrapsodyeco.com",
    deptCode: "DEPT_001",
    deptName: "Product Team",
    positionCode: "P001",
    positionName: "Manager",
    roleCode: "R001",
    roleName: "General User",
    serverToken: false,
    isServerToken: false,
  },
  ecoUserInfo: {
    userType: 1,
    status: 1,
    deptName: "Product Team",
    linkedYN: "Y",
    admin: false,
    remoteAddr: "127.0.0.1",
  },
  adminPermission: {
    ecoAdmin: false,
    allowMenus: [],
  },
  ecoCommonConfig: {
    externalUserViewType: "ALL",
    webOfficeAllowUserType: "ALL",
    restorePermission: "ALL",
    unwrappingPermission: "NONE",
    watermark: "ALL",
    fileUploadMaxSizeMB: 200,
    fileUploadConfigMaxSizeMB: 200,
    licenseAlertPercentage: 80,
    chatAvailibility: true,
    sentMail: false,
    passwordPolicyDTO: { minLength: 6, maxLength: 30 },
    lastUpdateTime: Date.now(),
    serviceType: "CLOUD",
    allowMobile: true,
    allowMacOS: true,
    watermarkPattern:
      "${username}(${userid}) / ${contentname} / ${currenttime} / demo",
    workgroupCreatePermission: "EXTERNAL",
    workgroupHeadSelectPermission: "ALL",
    fileUploadPermission: "EXTERNAL",
    fileOwnerSelectPermission: "ALL",
    autoUnwrappingPermission: false,
    activeHtmlWrapping: false,
    userOtpType: "NONE",
    watermarkTop: 59,
    watermarkFontSize: 16,
    watermarkOpacity: 0.2,
    watermarkRotate: 30,
    WebOfficeEditAllowUserType: "ALL",
    webOfficeType: "NONE",
    noneWorkgroupPolicyDTO: {
      policy: {
        startTime: 0,
        allowDays: 61,
        allowDaysTimeZone: 9.0,
        allowViewCount: 0,
        currentViewCount: 0,
        allowDownloadCount: 0,
        currentDownloadCount: 0,
        drmPerm: [],
        webView: true,
        revision: true,
        download: true,
        wrapping: true,
        additionalViewPermission: "NONE",
        fileShareLinkPolicy: {
          authType: "LOGIN",
          password: "",
          urlAction: "DOWNLOAD",
          allowDays: 61,
          allowDaysTimeZone: 0.0,
        },
        notificationPolicy: null,
      },
    },
    workgroupPermissionDTO: {
      changeCode: "CREATE",
      syncId: "NONE",
      targetType: "WORKGROUP",
      authType: "LOGIN",
      policyType: "TEMPLATE",
      updateTime: 1,
      createUser: "",
      updateUser: "",
      policy: {
        startTime: 0,
        allowDays: 61,
        allowDaysTimeZone: 9.0,
        allowViewCount: 0,
        currentViewCount: 0,
        allowDownloadCount: 0,
        currentDownloadCount: 0,
        drmPerm: [],
        webView: true,
        revision: true,
        download: true,
        wrapping: true,
        additionalViewPermission: "NONE",
        fileShareLinkPolicy: {
          authType: "LOGIN",
          password: "",
          urlAction: "DOWNLOAD",
          allowDays: 61,
          allowDaysTimeZone: 0.0,
        },
        notificationPolicy: null,
      },
    },
    workgroupTreeViewPermission: "ALL",
    workgroupTreeCreatePermission: "MASTER",
  },
  ecoSystemLicenseStats: {
    externalLicenseCount: 10,
    internalLicenseCount: 50,
    liteExternalLicenseCount: 0,
    usedExternalCount: 2,
    usedInternalCount: 10,
    usedLiteExternalCount: 0,
    allowMobile: true,
    allowMacOS: true,
    allowWebView: true,
    featureAccessType: "FULL",
  },
  serviceConfig: {
    disableExtensions: [],
    fwocExtensions: [
      "pdf",
      "docx",
      "doc",
      "xlsx",
      "xls",
      "pptx",
      "ppt",
      "hwp",
      "hwpx",
      "txt",
      "png",
      "jpg",
      "jpeg",
      "gif",
      "bmp",
    ],
    manualRevisionExtensions: ["docx", "doc", "xlsx", "xls", "pptx", "ppt"],
    revisionExtensions: ["docx", "doc", "xlsx", "xls", "pptx", "ppt"],
    webRevisionExtensions: [],
    hylandExtensions: [],
    zoomAvailibility: true,
    chatAvailibility: "true",
    companyName: "Wrapsody eCo Demo",
  },
};
